import { useEffect, useState } from 'react';

import { getInfo } from '../lib/api/api';
import { ERROR_RETRY } from '../lib/Error';
import { CONTRACT_INITIAL } from '../lib/util/userContract';

export const useGetInfo = () => {
  const [userInfo, setUserInfo] = useState(INITIAL_STATE);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = () => {
    setIsLoading(true);
    getInfo()
      .then((response) => {
        setUserInfo(response.data);
      })
      .catch((error) => {
        setIsError(error);
        alert(ERROR_RETRY);
      })
      .finally(() => setIsLoading(false));
  };

  return {
    userInfo,
    isLoading,
    isError,
  };
};

const INITIAL_STATE = {
  accountId: 0,
  contactInfo: null,
  name: '',
  email: '',
  contract: CONTRACT_INITIAL,
};
